export const AccountTrigger = () => {
  return <img src='/assets/icons/header/account.svg' alt='account' width={22} />
}
